<template>
  <StickyFooter :sticky="true">
    <template #header>
      <section class="hero is-info">
        <div class="loader-hero-body">
          <span class="loader-hero-title">Select Datasets</span>
          <ul class="loader-step-checklist">
            <li class="mr-2" :class="{ 'step-done': !!dropboxId }">
              Choose your dropbox
            </li>
            <li
              class="mr-2"
              :class="{
                'step-done':
                  dropboxSelectedFolder && dropboxSelectedFolder.name,
              }"
            >
              Choose the run folder
            </li>
            <li class="mr-2" :class="{ 'step-done': selectedFilesCount >= 1 }">
              Select datasets
            </li>
          </ul>
        </div>
      </section>
    </template>
    <template #body>
      <Databox
        style="height: 100%"
        v-bind="$attrs"
        @change-dropbox="resetSelectedFiles"
        @loading-dropboxes="(ld) => (isLoading = ld)"
      >
        <template #controls="{ reloadDropboxes }">
          <span class="icon is-small hoverable" @click="reloadDropboxes">
            <i class="fa fa-undo-alt fa-sm" />
          </span>
        </template>
        <template #explorer-right-bottom />
      </Databox>
    </template>
    <template #footer>
      <p
        v-if="hasInvalidCharacterFiles"
        class="has-text-warning has-text-weight-bold has-text-white mb-4"
      >
        <span class="icon has-text-warning mr-1">
          <i class="fa fa-exclamation-triangle" />
        </span>
        <a
          v-tooltip="{
            content: invalidFileNamesTooltip,
            popperClass: 'is-wide',
            html: true,
          }"
          class="has-text-warning"
          style="
            cursor: help;
            text-decoration: underline;
            text-underline-offset: 4px;
          "
        >
          {{ pluralize('file', invalidCharacterFiles.length, true) }}
        </a>
        {{ pluralize('contain', invalidCharacterFiles.length) }}
        invalid characters (: * ? " &lt; &gt; | or spaces)
      </p>
      <router-link :to="$attrs.nextRoute">
        <BaseButton
          :variant="canContinue ? 'primary' : undefined"
          :outlined="hasInvalidCharacterFiles"
          :disabled="!canContinue || isLoading"
          :icon="['fa', 'fa-step-forward']"
          label="Continue"
        />
      </router-link>
    </template>
  </StickyFooter>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import pluralize from 'pluralize'
import StickyFooter from '@/components/data-loader/StickyFooter.vue'
import Databox from '@/components/data-loader/Databox.vue'
export default {
  name: 'SelectDataView',
  components: {
    StickyFooter,
    Databox,
  },
  data() {
    return { isLoading: false }
  },
  computed: {
    ...mapState('dataloader/dropbox', {
      dropboxId: (state) => state?.data?.id,
      dropboxSelectedFolder: (state) => state.selectedFolder,
      transferWholeInputDir: (state) => state.transferWholeInputDir,
    }),
    ...mapGetters('dataloader/dropbox', {
      selectedFilesCount: 'filesCount',
      hasInvalidCharacterFiles: 'hasInvalidCharacterFiles',
      invalidCharacterFiles: 'invalidCharacterFiles',
    }),
    canContinue() {
      return this.selectedFilesCount > 0 && this.transferWholeInputDir !== null
    },
    invalidFileNamesTooltip() {
      const files = this.invalidCharacterFiles
        .slice(0, 10)
        .map((f) => `<li><code>${f.relativePath}</code></li>`)
        .join('')
      const more =
        this.invalidCharacterFiles.length > 10
          ? `<li>...and ${this.invalidCharacterFiles.length - 10} more</li>`
          : ''
      return `<ul>${files}${more}</ul>`
    },
  },
  methods: {
    pluralize,
    ...mapMutations('dataloader/dropbox', ['resetSelectedFiles']),
  },
}
</script>

<style scoped>
.explorer-panel {
  border: 1px solid var(--color-border-default);
}

.explorer-panel > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-border-default);
  background-color: var(--color-background-default);
  padding: 0.5rem 1rem;
}

.explorer-panel > header > .title {
  display: block;
}

.explorer-panel > section {
  padding: 1rem;
}
</style>
